import EchartBar from "./packages/bar";
import EchartPie from "./packages/pie";
import EchartLine from "./packages/line";
import EchartTable from "./packages/table";
import EchartFlop from "./packages/flop";
import EchartDatetime from "./packages/datetime";
import EchartText from "./packages/text";
import EchartSwiper from "./packages/swiper";
import EchartIframe from "./packages/iframe";
import EchartVideo from "./packages/video";
import EchartWordCloud from "./packages/wordCloud";
import EchartGauge from "./packages/gauge";
import EchartProgress from "./packages/progress";
import EchartMaps from "./packages/map";
import EchartImg from "./packages/img";
import EchartImgBorder from "./packages/imgBorder";
import EchartTabs from "./packages/tabs";
import EchartPictorialBar from "./packages/pictorialBar";
import EchartRadar from "./packages/radar";
import EchartFunnel from "./packages/funnel";
import EchartScatter from "./packages/scatter";
import EchartCommon from "./packages/common";
import EchartDatav from "./packages/datav";
import EchartClapper from "./packages/clappr";
import EchartTime from "./packages/time";
export default {
  EchartRadar: EchartRadar,
  EchartScatter: EchartScatter,
  EchartFunnel: EchartFunnel,
  EchartTabs: EchartTabs,
  EchartVideo: EchartVideo,
  EchartWordCloud: EchartWordCloud,
  EchartPictorialBar: EchartPictorialBar,
  EchartMaps: EchartMaps,
  EchartImg: EchartImg,
  EchartImgBorder: EchartImgBorder,
  EchartBar: EchartBar,
  EchartGauge: EchartGauge,
  EchartIframe: EchartIframe,
  EchartSwiper: EchartSwiper,
  EchartTable: EchartTable,
  EchartPie: EchartPie,
  EchartText: EchartText,
  EchartLine: EchartLine,
  EchartFlop: EchartFlop,
  EchartDatetime: EchartDatetime,
  EchartProgress: EchartProgress,
  EchartCommon: EchartCommon,
  EchartDatav: EchartDatav,
  EchartClapper: EchartClapper,
  EchartTime: EchartTime
};